
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, RepairOrdersActionCreator, ROHistoryActionCreator } from 'src/store/states';
import CurrentRepairCard from '../CurrentRepairCard';

const mapStateToProps = (state: IStoreState) => ({
    viewMode: state.Framework.viewMode,
    repairOrders: state.RepairOrders,
    customer: state.Customer.Customer!,
    vehicles: state.Vehicles,
    theme: state.Framework.theme,
    loadingROs: state.RepairOrders.loadingROs,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    locale: state.Framework.locale,
    selectedVehicle: state.Vehicles.selectedVehicle,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    fetchROs: RepairOrdersActionCreator.FetchROs,
    selectRO: RepairOrdersActionCreator.SelectRO,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    getReyPAYUrl: RepairOrdersActionCreator.GetReyPAYUrl,
    setLoadingROs: RepairOrdersActionCreator.SetLoadingROs,
    getROHistory: ROHistoryActionCreator.GetROHistory,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    toggleROLangLits: RepairOrdersActionCreator.ToggleROLangLits,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CurrentRepairCard);